/** Product naming. The one place these strings are written. */

export const PRODUCT_NAME = 'Eco Protector'
export const PRODUCT_TITLE =
  'Eco Protector — National Dam Break and Flash Flood Decision Support System'
export const PRODUCT_SUBTITLE = 'Hydrodynamic Inundation Modelling and Alert Dissemination'
export const PRODUCT_PROGRAMME = 'Smart India Hackathon 2026 · Problem Statement 26161 (NTRO)'
